import { type DehydratedState, HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { getQueryClient } from '@editorial/utils/functions/query-client/get-query-client';

type QueryProviderProps = React.PropsWithChildren<{ pageProps: { dehydratedState?: DehydratedState } }>;

export const QueryProvider = ({ children, pageProps }: QueryProviderProps) => {
    const queryClient = getQueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <HydrationBoundary state={pageProps.dehydratedState}>{children}</HydrationBoundary>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
};
